export const LEARNING_MATERIAL_LINK = 'https://billionminds.com/?app_token=6qEqyfgWHA6C5S2n5nnG';
export const BLOG_LINK = 'https://billionminds.com/blog/';
export const PODCAST_LINK = 'https://billionminds.com/podcast/';
export const REMOTE_WORK_TIP = 'https://billionminds.com/remoteworktip/';
export const PRODUCTIVITY_TIPS = 'https://www.billionminds.com/futureworkskills';

